import store from '@/store'
import getInitializedApi from '@/api'

let baseURL = process.env.ROOT_API

class ApiGEODP {
  get (url, params) {
    let headers = store.state.multiTenantAuthorization
    return getInitializedApi(baseURL, headers).get(url, { params: params })
  }

  post (url, params) {
    let headers = store.state.multiTenantAuthorization
    return getInitializedApi(baseURL, headers).post(url, params)
  }
}

export default new ApiGEODP()



// WEBPACK FOOTER //
// ./src/api/api_geodp.js